import { render, staticRenderFns } from "./CDataRow.vue?vue&type=template&id=0b6d20a9&"
import script from "./CDataRow.vue?vue&type=script&lang=js&"
export * from "./CDataRow.vue?vue&type=script&lang=js&"
import style0 from "./CDataRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports